// utils/imageOptimizer.js

// This utility function optimizes Unsplash image URLs by adding parameters for width and quality.

export const optimizeUnsplashUrl = (url, width = 800, quality = 80) => {
  if (!url || !url.includes('unsplash.com')) return url;
  
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('w', width);
    urlObj.searchParams.set('q', quality);
    urlObj.searchParams.set('auto', 'format');
    urlObj.searchParams.set('fit', 'crop');
    return urlObj.toString();
  } catch (error) {
    console.error('Error optimizing image URL:', error);
    return url;
  }
};